export default __webpack_public_path__ + "static/logo-williams-sonoma-f3913ab6943ea700bfda72a8899e1a6d.png";